import axios from "@/axios.config";

const state = {
  companies: [],
  uf: [],
  unidades: [],
  estabelecimentos: [],
  centro_custos: [],
  cargos: [],
  turnos: [],
  bancos: [],
  cidades: [],
};

const actions = {
  async loadCompanies({ commit }) {
    try {
      const { data } = await axios.get("/company/");
      if (!data.success) {
        throw new Error(data.message);
      }
      commit("SET_COMPANY", data);
    } catch (error) {
      throw new Error(error);
    }
  },

  async loadUf({ commit }) {
    try {
      const { data } = await axios.get("/uf");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_UF_LIST", data);
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  async loadUnidades({ commit }) {
    try {
      const { data } = await axios.get("/unidades");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_UNIDADES_LIST", data);
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  async loadEstabelecimentos({ commit }) {
    try {
      const { data } = await axios.get("/estabelecimentos");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_ESTABELECIMENTOS_LIST", data);
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  async loadCentroCustos({ commit }) {
    try {
      const { data } = await axios.get("/centro-custos");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_CENTRO_CUSTOS_LIST", data);
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  async loadCargos({ commit }) {
    try {
      const { data } = await axios.get("/cargos");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_CARGOS_LIST", data);
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  async loadTurnos({ commit }) {
    try {
      const { data } = await axios.get("/turnos");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_TURNOS_LIST", data);
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  async loadBancos({ commit }) {
    try {
      const { data } = await axios.get("/bancos");
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_BANCOS_LIST", data);
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },

  async loadCidades({ commit }, params) {
    try {
      const { data } = await axios.get("/cidades", {
        params
      });
      if (data.success === false) {
        throw new Error(data.message);
      }
      commit("SET_CIDADES_LIST", data);
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
};

const mutations = {
  SET_COMPANY: (state, companies) => {
    state.companies = companies.data;
  },
  SET_UF_LIST: (state, value) => {
    state.uf = value.data;
  },
  SET_UNIDADES_LIST: (state, value) => {
    state.unidades = value.data;
  },
  SET_ESTABELECIMENTOS_LIST: (state, value) => {
    state.estabelecimentos = value.data;
  },
  SET_CENTRO_CUSTOS_LIST: (state, value) => {
    state.centro_custos = value.data;
  },
  SET_CARGOS_LIST: (state, value) => {
    state.cargos = value.data;
  },
  SET_TURNOS_LIST: (state, value) => {
    state.turnos = value.data;
  },
  SET_BANCOS_LIST: (state, value) => {
    state.bancos = value.data;
  },
  SET_CIDADES_LIST: (state, value) => {
    state.cidades = value.data;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  mutations
};
